import { TextInput, SelectInput, ReferenceInput, FormDataConsumer, required, maxLength, NumberInput } from "react-admin";
import { Box } from "@mui/system";
import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import DomesticTripCategoryInput from "../Requests/components/businessTrip/DomesticTripCategoryInput";
import LocationRow from "../Requests/components/businessTrip/LocationRow";
import TravelersRow from "../Requests/components/businessTrip/TravelersRow";
import PersonalCarFields from "../Requests/components/businessTrip/PersonalCarFields";
import { BusinessTripMealProvidedChoices } from "utils/choices";
import { validateEnd, validateStart } from "utils/validations";
import {
  validateBusinessTripDays,
  validateDailyAllowanceDaysAndNights,
} from "components/Leaves/Requests/utils/validations";
import { employeeRequests } from "api/employeeApi";
import { BusinessTripTypes } from "utils/constants";

const SaveForm = () => {
  const businessTripType = useWatch({ name: "businessTripType" });
  const isDomestic = businessTripType === BusinessTripTypes.Internal;

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", pt: 5 }}>
      <Grid
        container
        spacing={0}
      >
        <Grid
          item
          xs={6}
          lg={3}
          p={0.5}
        >
          <ReferenceInput
            source="businessTripType"
            reference={employeeRequests.getBusinessTripsSelect()}
          >
            <SelectInput
              label="Тип командировка"
              optionText="nameBg"
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        <DomesticTripCategoryInput />
        <Grid
          item
          xs={6}
          lg={3}
          p={0.5}
        >
          <ReferenceInput
            source="transportType"
            reference={employeeRequests.getLeaveTransportsSelect()}
          >
            <SelectInput
              label="Тип транспорт"
              optionText="nameBg"
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        <PersonalCarFields />
        <TravelersRow />
        <FormDataConsumer>
          {({ formData }) => {
            return (
              <>
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={6}
                  >
                    <CustomDateInput
                      label="От дата"
                      source="dateFrom"
                      noTime
                      required={true}
                      validate={() =>
                        validateStart(
                          formData.dateFrom,
                          formData.dateTo,
                          required,
                          "Крайният ден не може да бъде по-малък от началният",
                        )
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                  >
                    <CustomDateInput
                      label="До дата"
                      source="dateTo"
                      noTime
                      required={true}
                      minDate={formData.dateFrom}
                      validate={() =>
                        validateEnd(
                          formData.dateTo,
                          formData.dateFrom,
                          required,
                          "Крайният ден не може да бъде по-малък от началният",
                        )
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <LocationRow />
                  <Grid
                    item
                    xs={12}
                    md={isDomestic ? 12 : 6}
                    p={0.5}
                  >
                    <TextInput
                      sx={{ mt: 3, mb: 0 }}
                      label="По маршрут"
                      source="route"
                      multiline
                      minRows={9}
                      validate={required()}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={6}
                  lg={2}
                  p={0.5}
                >
                  <SelectInput
                    label="Осигурено изхранване"
                    source="mealProvided"
                    choices={BusinessTripMealProvidedChoices}
                    validate={required()}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={3}
                  lg={2}
                  p={0.5}
                >
                  <NumberInput
                    label="Дневни пари на ден"
                    source="dailyAllowancePerDay"
                    min={0}
                    validate={required()}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={3}
                  lg={2}
                  p={0.5}
                >
                  <NumberInput
                    label="Брой дни с дневни пари"
                    source="dailyAllowanceDays"
                    min={0}
                    validate={[
                      required(),
                      validateBusinessTripDays(
                        formData.dateFrom,
                        formData.dateTo,
                        formData.dailyAllowanceDays,
                        formData.nightsCount,
                      ),
                      validateDailyAllowanceDaysAndNights(formData.dailyAllowanceDays, formData.nightsCount),
                    ]}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={3}
                  lg={2}
                  p={0.5}
                >
                  <NumberInput
                    label="Макс. сума за нощувка"
                    source="maxAccommodationAmountPerNight"
                    min={0}
                    validate={required()}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={3}
                  lg={2}
                  p={0.5}
                >
                  <NumberInput
                    label="Брой нощувки"
                    source="nightsCount"
                    min={0}
                    validate={required()}
                  />
                </Grid>
              </>
            );
          }}
        </FormDataConsumer>
        <Grid
          item
          xs={12}
          sm={6}
          p={0.5}
        >
          <TextInput
            type="textarea"
            label="Платец на разходите"
            source="expensePayer"
            multiline
            minRows={3}
            validate={[required(), maxLength(300)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          p={0.5}
        >
          <TextInput
            type="textarea"
            label={isDomestic ? "Задача" : "Причина за командировката"}
            source="assignment"
            multiline
            minRows={3}
            validate={[required(), maxLength(500)]}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SaveForm;
